import { useEffect, useState } from 'react';

import Countdown from './components/Countdown';
import {
  WWDC_DATE_LABEL,
  WWDC_HERO_URL,
  WWDC_TARGET_DATE,
  getCountdownAriaLabel,
  getCountdownSegments,
  getTimeRemaining,
  type TimeRemaining
} from './config/wwdc';

const WWDC: React.FC = () => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const updateTimeRemaining = () => {
      setTimeRemaining(getTimeRemaining(WWDC_TARGET_DATE));
    };

    updateTimeRemaining();
    const interval = setInterval(updateTimeRemaining, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const delayTransition = setTimeout(() => {
      setShowCountdown(true);
    }, 2000); // Adjust delay time as needed

    return () => clearTimeout(delayTransition);
  }, []);

  const countdownSegments = getCountdownSegments(timeRemaining);
  const countdownAriaLabel = getCountdownAriaLabel(timeRemaining);
  const isCountdownComplete = countdownSegments.every((segment) => segment.value === '00' || segment.value === '0');

  return (
    <main className="wwdc-page flex min-h-screen flex-col items-center justify-center px-0 py-10 sm:px-10">
      <div className="wwdc-stack">
        <div className="hero-logo-wrap">
          <img
            className="hero-logo"
            src={WWDC_HERO_URL}
            alt="WWDC26 logo"
          />
        </div>
        {!isCountdownComplete && (
          <div className="countdown-shell text-center opacity-100 transition-opacity duration-500">
            {showCountdown ? (
              <Countdown ariaLabel={countdownAriaLabel} segments={countdownSegments} />
            ) : (
              <p className="countdown-display countdown-date">
                <span className="countdown-display__text">{WWDC_DATE_LABEL}</span>
              </p>
            )}
          </div>
        )}
      </div>
    </main>
  );
};

export default WWDC;
